module.exports = __webpack_public_path__ + "img/p08201.07c23310.png";